/* eslint-disable max-len */
import React from 'react';

const OrderedListIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M6 14v4H3v-1h2v-.5H4v-1h1V15H3v-1h3zm11 2v1H8v-1h9zM6 8v1.809l-2 1V11h2v1H3v-1.809l2-1V9H3V8h3zm11 2v1H8v-1h9zM5 2v4H4V3H3V2h2zm12 2v1H8V4h9z"
            transform="translate(-469.000000, -79.000000) translate(466.000000, 77.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default OrderedListIcon;
